<template>
  <div>
    <common-header title="설문조사" :showTitle="true" :showCart="false" :showHome="true" :showBack="true"/>
    <main class="benefit stamp stamp-card">
      <SurveyTab/>
      <SurveyList/>
    </main>
  </div>
</template>

<script>
import SurveyTab from './common/SurveyTab.vue'
import SurveyList from './SurveyList'
import {mapMutations} from "vuex";
import {YN} from "../AppConstants";

export default {
  components: {
    SurveyTab,
    SurveyList,
  },
  created() {
    // TODO 네비게이션 가드로 리팩토링
    // 로그인 상태 체크
    if (this.loginState != true) {
      this.$router.push('/')
      return;
    }

    // 파라미터 확인
    if (this.$route.query.answerYn != null && this.$route.query.answerYn === YN.Y) {
      this.SET_SURVEY_ANSWER_YN(YN.Y);
    }
  },
  methods: {
    ...mapMutations(['SET_SURVEY_ANSWER_YN'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/SurveyMain.vue